import React, { useCallback, useEffect } from 'react';
import { Button } from 'src/components/Button/Button';
import './modal.scss';

interface Props {
  header: string | null;
  confirmButton: string;
  description: string;
  onCloseDialog: (returnData: boolean) => void;
  onConfirmFunction?: () => void;
  disabled?: boolean;
  className?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  disableCancelButton?: boolean;
  icon?: string;
}

export const Modal: React.FC<Props> = ({
  header,
  confirmButton,
  onCloseDialog,
  description,
  onConfirmFunction,
  disabled,
  className,
  children,
  disableCancelButton,
  showConfirmButton,
  showCancelButton = true,
  icon,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const clickHandler = useCallback(
    result => {
      return (): void => {
        result && onConfirmFunction && onConfirmFunction();
        !result && onCloseDialog(result);
      };
    },
    [onCloseDialog, onConfirmFunction],
  );

  return (
    <div className={`modal-backdrop ${className}`}>
      <div className="modal-wrapper">
        <div className="modal">
          {icon && (
            <div className="center">
              <i className="icon i-warning" />
            </div>
          )}
          {header && <div className="modal-title">{header}</div>}
          <div className="modal-content">{description}</div>
          {children && <div className="modal-children">{children}</div>}
          <div className="modal-btn">
            {showConfirmButton && (
              <Button
                title={confirmButton}
                className="certify-log-btn"
                onClick={clickHandler(true)}
                disabled={disabled}
              />
            )}
            {showCancelButton && (
              <Button
                title="Cancel"
                className="cancel-btn"
                disabled={disableCancelButton}
                onClick={clickHandler(false)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.defaultProps = {
  showConfirmButton: true,
};
